import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { Flex, Center, Icon, Box, VStack, Text } from '@wegroup/design-system';

interface Props {
  isCompleted: boolean;
  inProgress?: boolean;
  onClick?: () => void;
  disabled?: boolean;
}

const ProgressBarItem: React.FC<React.PropsWithChildren<Props>> = ({
  isCompleted,
  inProgress,
  children,
  onClick,
  disabled,
}) => {
  const theme = useContext(ThemeContext);
  const mainColor = theme['isImmo'] ? 'secondary.200' : 'secondary.300';

  return (
    <Flex
      h="100%"
      maxH="20"
      _last={{
        height: 'auto',
        // hide line on last item
        '.FLOWS_TOOLBAR_PROGRESS_DIVIDER': { display: 'none' },
      }}
      {...(!disabled && { onClick })}
    >
      <Flex alignItems="center" flexDir="column">
        <Center
          bg={isCompleted ? mainColor : 'none'}
          flexShrink={0}
          borderRadius="full"
          w="5"
          h="5"
          border="1px"
          borderColor={mainColor}
        >
          {isCompleted && (
            <Icon name="GeneralStatusSuccessCheckmark" color="secondary.800" />
          )}
        </Center>
        {/* Line */}
        <Box
          className="FLOWS_TOOLBAR_PROGRESS_DIVIDER"
          w="1px"
          h="100%"
          bg={mainColor}
          mt="2"
        />
      </Flex>
      <VStack spacing="2" ml="6" cursor={disabled ? 'default' : 'pointer'}>
        <Text
          textStyle="normalBodyMedium"
          color={mainColor}
          textTransform="uppercase"
          textDecoration={inProgress ? 'underline' : 'none'}
        >
          {children}
        </Text>
      </VStack>
    </Flex>
  );
};

export default ProgressBarItem;
